import React, {Component} from 'react';

class Paging extends Component{
  constructor(props){
    super(props)
    this.handleClick = this.handleClick.bind(this)
  }

  handleClick (event) {

    let search = "https://search.olympus-global.com"+ event.target.getAttribute("href") + "&sxml=on"
    //let search = "./search.xml?"+submit_values.join('&') + "&" + submit_do_elements.join('&') + "&sxml=on"
    this.props.loadSet(true)
    this.props.urlSet(search)

  }

  render(){
    return(
      <ul className="nav-pager-01">
        {(() => {
          //prev button
          if(this.props.parameterPage !== 1 && this.props.totalPages!== 0){
            return (
              <li key="prevButton" className="prev"><a href={window.location.search.replace(/&?page=\d+/,"") + '&page='+(this.props.parameterPage - 1)} onClick={(e) => this.handleClick(e)}><span>Previous</span></a></li>
            )
          }
        })()}
        {(() => {
          if(this.props.totalPages!== 0 && this.props.pagesArray.length !== 0){
            return (
              this.props.pagesArray.map((p, index) => {
                if(p === this.props.parameterPage){
                  return(
                    <li key={index}><ul><li><a className="current" href={window.location.search.replace(/&?page=\d+/,"") + '&page='+p} onClick={(e) => this.handleClick(e)}>{p}<span>ページ目へ</span></a></li></ul></li>
                  )
                }else{
                  return(
                    <li key={index}><ul><li><a href={window.location.search.replace(/&?page=\d+/,"") + '&page='+p} onClick={(e) => this.handleClick(e)}>{p}<span>ページ目へ</span></a></li></ul></li>
                  )
                }
              })
            )
          }
        })()}
        {(() => {
          //next button
          if(this.props.totalPages !== this.props.parameterPage && this.props.totalPages > 0){
            return (
              <li key="nextButton" className="next"><a href={window.location.search.replace(/&?page=\d+/,"") + '&page='+(this.props.parameterPage + 1)} onClick={(e) => this.handleClick(e)}><span>Next</span></a></li>
            )
          }
        })()}
      </ul>
    )
  }
}

export default Paging
